import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import staketext from "./assets/staketext.svg";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SwipeableViews from "react-swipeable-views";

//animations

import c1 from "./assets/c1.svg";
import c2 from "./assets/c2.svg";
import c3 from "./assets/c3.svg";
import c4 from "./assets/c4.svg";

import f1 from "./assets/f1.svg";
import f2 from "./assets/f2.svg";
import f3 from "./assets/f3.svg";
import f4 from "./assets/f4.svg";
import f5 from "./assets/f5.svg";
import f6 from "./assets/f6.svg";

import mc1 from "./mAssets/c1.svg";
import mf1 from "./mAssets/f1.svg";
import mf2 from "./mAssets/f2.svg";

import { formatUnits, parseUnits } from "@ethersproject/units";

// Contract Import

import {
  useStakingContract,
  ToastNotify,
  useLpContract,
  useMainnodeContract,
  useUsdcContract,
} from "../../ConnectivityAss/hooks";

import { useContext } from "react";
import { AppContext, gasEstimationForAll } from "../../utils";
import Loading from "../../loading";
import {
  mainNodeAddress,
  stakingAddress,
} from "../../ConnectivityAss/Environment";
import CustomTable from "./CustomTable";

function Stake() {
  const mobile = useMediaQuery("(max-width:1050px)");
  const mobile2 = useMediaQuery("(max-width:400px)");

  // context API

  const { account, signer, connect } = useContext(AppContext);

  // Contract State
  const stakingContract = useStakingContract(signer);
  const lpContract = useLpContract(signer);
  const mainNodeContract = useMainnodeContract(signer);
  const usdcContract = useUsdcContract(signer);

  // Contract States
  const [CardsState, setCardsState] = useState(1);
  const [LpInput, setLpInput] = useState("");
  const [loading, setloading] = useState(false);
  const [pendingReward, setpendingReward] = useState(0);
  const [stakedLp, setstakedLp] = useState(0);
  const [stakedLpValue, setstakedLpValue] = useState(0);
  const [TVL, setTVL] = useState(0);
  const [conversionRate, setconvesionRate] = useState(0);
  const [conversionCost1, setconvesionCost1] = useState(0);
  const [conversionCost2, setconvesionCost2] = useState(0);
  const [conversionCost3, setconvesionCost3] = useState(0);
  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });
  const [usdcBalance, setusdcBalance] = useState(0);
  const [lpBalance, setlpBalance] = useState(0);
  const [lpPriceUSDC, setlpPriceUSDC] = useState(0);
  const [nodeTypeIndex, setnodeTypeIndex] = useState("0");

  // APR Formula states

  const [conPerBlock, setconPerBlock] = useState(0);
  const [conPrice, setconPrice] = useState(0);

  const init = async () => {
    if (account) {
      const [
        decimal,
        balance,
        pending,
        { amount },
        tvl,
        usdcbalance,
        usdcDecimal,
        conversionDiscount,
        cost1,
        cost2,
        cost3,
        lpPrice,
        conPerBlock,
        conPrice,
      ] = await Promise.all([
        lpContract.decimals(),
        lpContract.balanceOf(account),
        stakingContract.pendingRewards(account),
        stakingContract.userInfo(account),
        lpContract.balanceOf(stakingAddress),
        usdcContract.balanceOf(account),
        usdcContract.decimals(),
        mainNodeContract.conversionDiscount(),
        mainNodeContract.getNodeCostWithLPAndConvertDiscount("0", "1"),
        mainNodeContract.getNodeCostWithLPAndConvertDiscount("1", "1"),
        mainNodeContract.getNodeCostWithLPAndConvertDiscount("2", "1"),
        mainNodeContract.getUSDCForLP(parseUnits("1")),
        stakingContract.getCurrentRewardsPerBlock(),
        mainNodeContract.getUSDCForCON(parseUnits("1")),
      ]);
      setconPerBlock(formatUnits(conPerBlock));
      setconPrice(formatUnits(conPrice, 6));
      const finalTvl = await mainNodeContract.getUSDCForLP(tvl);
      const stakedlpValue = await mainNodeContract.getUSDCForLP(amount);
      setlpBalance((+formatUnits(balance, decimal)).toFixed(5));
      setusdcBalance((+formatUnits(usdcbalance, usdcDecimal)).toFixed(2));
      setpendingReward((+formatUnits(pending, decimal)).toFixed(2));
      setstakedLp((+formatUnits(amount, decimal)).toFixed(5));
      setstakedLpValue((+formatUnits(stakedlpValue, usdcDecimal)).toFixed(5));
      setTVL((+formatUnits(finalTvl, usdcDecimal)).toFixed(2));
      setconvesionRate((+conversionDiscount / 100).toFixed(2));
      setconvesionCost1((+formatUnits(cost1, usdcDecimal)).toFixed(2));
      setconvesionCost2((+formatUnits(cost2, usdcDecimal)).toFixed(2));
      setconvesionCost3((+formatUnits(cost3, usdcDecimal)).toFixed(2));
      setlpPriceUSDC((+formatUnits(lpPrice, usdcDecimal)).toFixed(2));
    }
  };
  useEffect(() => {
    init();
  }, [account]);

  // Approve USDC
  const approveUSDC = async () => {
    try {
      setloading(true);
      const [balance, allowance] = await Promise.all([
        usdcContract.balanceOf(account),
        usdcContract.allowance(account, mainNodeAddress),
      ]);
      if (+allowance < +balance) {
        let data = [mainNodeAddress, balance];
        let fn = usdcContract.estimateGas.approve;
        let tx = await usdcContract.approve(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
      }
      await init();
      setloading(false);
      setAlertState({
        open: true,
        message: `Approved Successfully`,
        severity: "success",
      });
    } catch (error) {
      console.log(error);
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  // Approve LP
  const approveLp = async (address) => {
    try {
      setloading(true);
      const [balance, allowance] = await Promise.all([
        lpContract.balanceOf(account),
        lpContract.allowance(account, address),
      ]);
      if (+allowance < +balance) {
        let data = [address, balance];
        let fn = lpContract.estimateGas.approve;
        let tx = await lpContract.approve(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
      }
      await init();
      setloading(false);
      setAlertState({
        open: true,
        message: `Approved Successfully`,
        severity: "success",
      });
    } catch (error) {
      console.log(error);
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };

  // Withdraw

  const withdrawHandler = async () => {
    try {
      if (!LpInput || isNaN(LpInput) || +LpInput <= 0) {
        setAlertState({
          open: true,
          message: "Please enter a valid amount",
          severity: "error",
        });
      } else {
        setloading(true);
        let data = [parseUnits(LpInput)];
        let fn = stakingContract.estimateGas.withdraw;
        let tx = await stakingContract.withdraw(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
        await init();
        setloading(false);

        setAlertState({
          open: true,
          message: `Transaction Successfully completed`,
          severity: "success",
        });
      }
    } catch (error) {
      console.log(error);
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  // ZAP LP

  const zapLPHandler = async () => {
    try {
      if (!LpInput || isNaN(LpInput) || +LpInput <= 0) {
        setAlertState({
          open: true,
          message: "Please enter a valid amount",
          severity: "error",
        });
      } else {
        setloading(true);
        const decimal = await usdcContract.decimals();
        let data = [parseUnits(LpInput, decimal)];
        let fn = mainNodeContract.estimateGas.zapLiquidity;
        let tx = await mainNodeContract.zapLiquidity(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
        await init();
        setloading(false);

        setAlertState({
          open: true,
          message: `Transaction Successfully completed`,
          severity: "success",
        });
      }
    } catch (error) {
      console.log(error);
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  // Deposit LP

  const DepositLP = async () => {
    try {
      if (!LpInput || isNaN(LpInput) || +LpInput <= 0) {
        setAlertState({
          open: true,
          message: "Please enter a valid amount",
          severity: "error",
        });
      } else {
        setloading(true);
        let data = [parseUnits(LpInput)];
        let fn = stakingContract.estimateGas.deposit;
        let tx = await stakingContract.deposit(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
        await init();
        setloading(false);

        setAlertState({
          open: true,
          message: `Transaction Successfully completed`,
          severity: "success",
        });
      }
    } catch (error) {
      console.log(error);
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  // Convert Handler
  console.log(nodeTypeIndex, "nodeTypeIndex");
  const convertHandler = async () => {
    try {
      if (!LpInput || isNaN(LpInput) || +LpInput <= 0) {
        setAlertState({
          open: true,
          message: "Please enter a valid amount",
          severity: "error",
        });
      } else {
        setloading(true);
        let data = [
          stakingAddress,
          parseUnits(LpInput),
          nodeTypeIndex.toString(),
        ];
        let fn = mainNodeContract.estimateGas.convertStakeIntoNodes;
        let tx = await mainNodeContract.convertStakeIntoNodes(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
        await init();
        setloading(false);

        setAlertState({
          open: true,
          message: `Transaction Successfully completed`,
          severity: "success",
        });
      }
    } catch (error) {
      console.log(error);
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  // Claim Reward

  const claimRewardsHandler = async () => {
    try {
      setloading(true);
      let data = [account];
      let fn = stakingContract.estimateGas.harvest;
      let tx = await stakingContract.harvest(...data, {
        gasLimit: gasEstimationForAll(account, fn, data),
      });
      await tx.wait();
      await init();
      setloading(false);

      setAlertState({
        open: true,
        message: `Transaction Successfully completed`,
        severity: "success",
      });
    } catch (error) {
      console.log(error);
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };

  useEffect(() => {
    if (!account) {
      connect();
    }
  }, [account]);

  // mui tabs

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div
      style={{
        background:
          "radial-gradient(68.29% 68.29% at 50% 50%, #73246C 0%, #1A103B 100%)",
        backgroundSize: "cover",
        width: "100%",
        paddingTop: "75px",
        paddingBottom: "75px",
        zIndex: "-5",

        overflowX: "hidden",
      }}
    >
      <ToastNotify alertState={alertState} setAlertState={setAlertState} />
      <Loading loading={loading} />
      <Container sx={{ maxWidth: "xl" }}>
        {mobile ? (
          <></>
        ) : (
          <>
            {/* f2  */}
            <Box sx={{ position: "relative" }}>
              <img
                src={f2}
                className="updown"
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "320px",
                  marginLeft: "-40px",
                }}
                alt=""
              />

              {/* c1  */}

              <img
                className="rotateY"
                src={c1}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "100px",
                  marginLeft: "-100px",
                }}
                alt=""
              />
              {/* f1  */}

              <img
                className="diagonal"
                src={f1}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "130px",
                  marginLeft: "-20px",
                }}
                alt=""
              />
              {/* f3  */}

              <img
                src={f3}
                className="updown"
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-70px",
                  marginLeft: "800px",
                }}
                alt=""
              />
              {/* f5  */}

              <img
                className="updown"
                src={f5}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "260px",
                  marginLeft: "1090px",
                }}
                alt=""
              />
              {/* c3  */}

              <img
                className="rotate"
                src={c3}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "100px",
                  marginLeft: "1000px",
                }}
                alt=""
              />

              {/* f4  */}

              <img
                className="rotate"
                src={f4}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "60px",
                  marginLeft: "1100px",
                }}
                alt=""
              />
            </Box>
          </>
        )}

        <Box
          className="border"
          width="100%"
          px={mobile ? "18px" : "70px"}
          py={mobile ? "20px" : "48px"}
          sx={{
            background: " rgba(248, 248, 248, 0.1)",
            backdropFilter: "blur(10px)",
            borderRadius: "20px",
            zIndex: "100",
            maxWidth: "800px",
            margin: "auto",
            textAlign: "center",
          }}
        >
          <img
            style={{ width: "100%", maxWidth: "518px", height: "auto" }}
            src={staketext}
          />
          <Typography
            fontSize={mobile ? "12px" : "20px"}
            variant="h6"
            color="white"
            fontFamily={"regular"}
          >
            Stake CON-USDC LP Tokens to earn CON
          </Typography>

          <Tabs className="tabs" defaultIndex={0}>
            <Box
              sx={{
                width: mobile ? "100%" : "80%",
                margin: "10px auto 0px auto",
              }}
            >
              <TabList>
                <Stack direction="row" justifyContent="space-around">
                  {" "}
                  <Tab style={{ border: "none !important" }}>
                    <Button
                      onClick={() => {
                        setCardsState(1);
                      }}
                      sx={{
                        background: "transparent",
                        color: CardsState === 1 ? "#DA251D" : "#E8D647",
                        "&:hover": { color: "#DA251D" },
                        "&active:": { color: "#DA251D" },
                        fontSize: mobile2 ? "10px" : mobile ? "12px" : "20px",
                        fontFamily: "semi",
                        borderBottom:
                          CardsState === 1 ? "2px solid #ffffff" : "none",
                        borderRadius: "0px",
                      }}
                    >
                      CREATE
                    </Button>{" "}
                  </Tab>
                  <Tab>
                    <Button
                      onClick={() => {
                        setCardsState(2);
                      }}
                      sx={{
                        background: "transparent",
                        color: CardsState === 2 ? "#DA251D" : "#E8D647",
                        "&:hover": { color: "#DA251D" },
                        "&active:": { color: "#DA251D" },
                        fontSize: mobile2 ? "10px" : mobile ? "12px" : "20px",
                        fontFamily: "semi",
                        borderBottom:
                          CardsState === 2 ? "2px solid #ffffff" : "none",
                        borderRadius: "0px",
                      }}
                    >
                      DEPOSIT
                    </Button>
                  </Tab>
                  <Tab>
                    <Button
                      onClick={() => {
                        setCardsState(3);
                      }}
                      sx={{
                        background: "transparent",
                        color: CardsState === 3 ? "#DA251D" : "#E8D647",
                        "&:hover": { color: "#DA251D" },
                        "&active:": { color: "#DA251D" },
                        fontSize: mobile2 ? "10px" : mobile ? "12px" : "20px",
                        fontFamily: "semi",
                        borderBottom:
                          CardsState === 3 ? "2px solid #ffffff" : "none",
                        borderRadius: "0px",
                      }}
                    >
                      WITHDRAW
                    </Button>
                  </Tab>
                  <Tab>
                    <Button
                      onClick={() => {
                        setCardsState(4);
                      }}
                      sx={{
                        background: "transparent",
                        color: CardsState === 4 ? "#DA251D" : "#E8D647",
                        "&:hover": { color: "#DA251D" },
                        "&active:": { color: "#DA251D" },
                        fontSize: mobile2 ? "10px" : mobile ? "12px" : "20px",
                        fontFamily: "semi",
                        borderBottom:
                          CardsState === 4 ? "2px solid #ffffff" : "none",
                        borderRadius: "0px",
                      }}
                    >
                      CONVERT
                    </Button>
                  </Tab>
                </Stack>
              </TabList>
            </Box>
            <Box
              sx={{
                width: "100%",
                maxWidth: "400px",
                margin: "20px auto 20px auto",
                fontFamily: "regular",

                fontSize: mobile ? "15px" : "20px",
              }}
            >
              <Grid container mt={1}>
                <Grid item xs={4} sx={{ color: "white" }}>
                  APR
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  :
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  {TVL > 0
                    ? (
                        ((conPrice * 36000 * 365 * conPerBlock) / TVL) *
                        100
                      ).toFixed(3)
                    : "0"}
                  %
                </Grid>
              </Grid>
              <Grid container mt={1}>
                <Grid item xs={4} sx={{ color: "white" }}>
                  TVL
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  :
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  ${TVL}
                </Grid>
              </Grid>
              <Grid container mt={1}>
                <Grid item xs={4} sx={{ color: "white" }}>
                  YOUR LP BALANCE
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  :
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  {lpBalance}
                </Grid>
              </Grid>
              <Grid container mt={1}>
                <Grid item xs={4} sx={{ color: "white" }}>
                  YOUR STAKED LP
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  :
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  {stakedLp}
                </Grid>
              </Grid>
              <Grid container mt={1}>
                <Grid item xs={4} sx={{ color: "white" }}>
                  STAKED VALUE
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  :
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  ${stakedLpValue}
                </Grid>
              </Grid>
              <Grid container mt={1}>
                <Grid item xs={4} sx={{ color: "white" }}>
                  PENDING CON
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  :
                </Grid>
                <Grid item xs={4} sx={{ color: "white" }}>
                  {pendingReward}
                </Grid>
              </Grid>
            </Box>

            {account ? (
              <Button
                sx={{
                  fontSize: mobile ? "15px" : "25px",
                  background: "#E30613",
                  "&:hover": {
                    background: "white",
                    color: "#E30613",
                  },
                  color: "white",
                  borderRadius: "10px",
                  fontWeight: "600",
                  marginTop: mobile ? "10px" : "0px",
                  fontFamily: "light",
                  paddingX: "25px",
                }}
                onClick={claimRewardsHandler}
              >
                Claim Rewards
              </Button>
            ) : (
              <Button
                sx={{
                  fontSize: mobile ? "15px" : "25px",
                  background: "#E30613",
                  "&:hover": {
                    background: "white",
                    color: "#E30613",
                  },
                  color: "white",
                  borderRadius: "10px",
                  fontWeight: "600",
                  marginTop: mobile ? "10px" : "0px",
                  fontFamily: "light",
                  paddingX: "25px",
                }}
                onClick={connect}
              >
                CONNECT WALLET
              </Button>
            )}

            <Box textAlign="center" mt={2}>
              <Typography
                paragraph
                fontSize={mobile ? " 20px" : "15px"}
                sx={{ color: "white", fontFamily: "regular" }}
              >
                Enter Amount
              </Typography>
              <OutlinedInput
                id="outline"
                endAdornment={
                  <Box
                    fontSize={mobile ? " 20px" : "15px"}
                    sx={{
                      color: "white",
                      fontFamily: "regular",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (CardsState === 1) {
                        setLpInput(usdcBalance);
                      } else if (CardsState === 2) {
                        setLpInput(lpBalance);
                      } else if (CardsState === 3) {
                        setLpInput(stakedLp);
                      } else if (CardsState === 4) {
                        setLpInput(stakedLp);
                      }
                    }}
                  >
                    MAX
                  </Box>
                }
                sx={{
                  background: "#4A4A4A",
                  borderRadius: "10px",
                  width: "70%",
                  height: "50px",
                  color: "white",
                  fontFamily: "regular",
                }}
                value={LpInput}
                onChange={(event) => setLpInput(event.target.value)}
                placeholder="Enter Amount"
              />
            </Box>
            <Box
              textAlign={"center"}
              sx={{ color: "white", fontFamily: "regular" }}
            >
              {/* //   Create  */}
              <TabPanel className="panal">
                <Typography
                  paragraph
                  mt={2}
                  sx={{ fontFamily: "regular" }}
                  fontSize={mobile ? "15px" : "15px"}
                >
                  Zap using USDC (automatically convert USDC into LP):
                </Typography>
                <Stack
                  justifyContent={"center"}
                  sx={{ margin: "15px auto 15px auto" }}
                  direction="row"
                  spacing={3}
                >
                  {account ? (
                    <>
                      {" "}
                      <Button
                        sx={{
                          fontSize: mobile ? "15px" : "25px",
                          background: "#FAA631",
                          "&:hover": {
                            background: "white",
                            color: "#FAA631",
                          },
                          color: "white",
                          borderRadius: "10px",
                          paddingX: "20px",
                          fontFamily: "light",
                        }}
                        onClick={approveUSDC}
                      >
                        APPROVE USDC
                      </Button>
                      <Button
                        sx={{
                          fontSize: mobile ? "15px" : "25px",
                          background: "#FAA631",
                          "&:hover": {
                            background: "white",
                            color: "#FAA631",
                          },
                          color: "white",
                          borderRadius: "10px",
                          fontFamily: "light",
                          paddingX: "20px",
                        }}
                        onClick={zapLPHandler}
                      >
                        ZAP LP
                      </Button>
                    </>
                  ) : (
                    <Button
                      sx={{
                        fontSize: mobile ? "15px" : "25px",
                        background: "#FAA631",
                        "&:hover": {
                          background: "white",
                          color: "#FAA631",
                        },
                        color: "white",
                        borderRadius: "10px",
                        fontFamily: "light",
                        paddingX: "20px",
                      }}
                      onClick={connect}
                    >
                      CONNECT WALLET
                    </Button>
                  )}{" "}
                </Stack>
              </TabPanel>
              {/* // Deposite  */}
              <TabPanel className="panal">
                <Stack
                  justifyContent={"center"}
                  sx={{ margin: "15px auto 15px auto" }}
                  direction="row"
                  spacing={3}
                >
                  {account ? (
                    <>
                      {" "}
                      <Button
                        sx={{
                          fontSize: mobile ? "15px" : "25px",
                          background: "#FAA631",
                          "&:hover": {
                            background: "white",
                            color: "#FAA631",
                          },
                          color: "white",
                          borderRadius: "10px",
                          paddingX: "20px",
                          fontFamily: "light",
                        }}
                        onClick={() => approveLp(stakingAddress)}
                      >
                        APPROVE LP
                      </Button>
                      <Button
                        onClick={DepositLP}
                        sx={{
                          fontSize: mobile ? "15px" : "25px",
                          background: "#FAA631",
                          "&:hover": {
                            background: "white",
                            color: "#FAA631",
                          },
                          color: "white",
                          borderRadius: "10px",
                          fontFamily: "light",
                          paddingX: "20px",
                        }}
                      >
                        Deposit
                      </Button>
                    </>
                  ) : (
                    <Button
                      sx={{
                        fontSize: mobile ? "15px" : "25px",
                        background: "#FAA631",
                        "&:hover": {
                          background: "white",
                          color: "#FAA631",
                        },
                        color: "white",
                        borderRadius: "10px",
                        fontFamily: "light",
                        paddingX: "20px",
                      }}
                      onClick={connect}
                    >
                      CONNECT WALLET
                    </Button>
                  )}{" "}
                </Stack>
              </TabPanel>
              {/* Withdraw  */}
              <TabPanel className="panal">
                <Stack
                  justifyContent={"center"}
                  sx={{ margin: "15px auto 15px auto" }}
                  direction="row"
                  spacing={3}
                >
                  {account ? (
                    <Button
                      sx={{
                        fontSize: mobile ? "15px" : "25px",
                        background: "#FAA631",
                        "&:hover": {
                          background: "white",
                          color: "#FAA631",
                        },
                        color: "white",
                        borderRadius: "10px",
                        fontFamily: "light",
                        paddingX: "50px",
                      }}
                      onClick={withdrawHandler}
                    >
                      WITHDRAW
                    </Button>
                  ) : (
                    <Button
                      sx={{
                        fontSize: mobile ? "15px" : "25px",
                        background: "#FAA631",
                        "&:hover": {
                          background: "white",
                          color: "#FAA631",
                        },
                        color: "white",
                        borderRadius: "10px",
                        fontFamily: "light",
                        paddingX: "20px",
                      }}
                      onClick={connect}
                    >
                      CONNECT WALLET
                    </Button>
                  )}{" "}
                </Stack>
              </TabPanel>

              {/* // Convert   */}

              <TabPanel className="panal">
                <Typography mt={3} color="#FAA631" paragraph>
                  (Only available to people who have staked LP tokens for at
                  least 3 days!)
                </Typography>

                <Box
                  mt={3}
                  sx={{
                    padding: "20px 0px",
                    borderTop: "1px solid #FAA631",
                    borderBottom: "1px solid #FAA631",
                  }}
                >
                  <Typography paragraph color="#FAA631">
                    <span style={{ fontWeight: "bold" }}>Important:</span>
                    Converting does the following things:
                  </Typography>
                  <Typography paragraph>
                    1. Withdraws your staked LP balance
                  </Typography>
                  <Typography paragraph>
                    2. Converts it into JACKPOT NODE at their LP discounted
                    value
                  </Typography>
                  <Typography paragraph>
                    3. Return to you any excess LP tokens
                  </Typography>
                  <Typography paragraph>
                    4. Return to you all of your pending CON rewards
                  </Typography>
                </Box>

                {/* // table  */}

                <CustomTable
                  lpPriceUSDC={lpPriceUSDC}
                  stakedLp={stakedLp}
                  conversionRate={conversionRate}
                  conversionCost1={conversionCost1}
                  conversionCost2={conversionCost2}
                  conversionCost3={conversionCost3}
                  setnodeTypeIndex={setnodeTypeIndex}
                  nodeTypeIndex={nodeTypeIndex}
                />

                {/* <Box mt={2}>
                  <Typography paragraph>
                    Current Conversion Discount:
                  </Typography>
                  <Typography paragraph color="#FAA631">
                    {conversionRate}%
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography paragraph>
                    Node Price (w/ LP + Conversion discount):
                  </Typography>
                  <Typography paragraph color="#FAA631">
                    ${conversionCost}
                  </Typography>
                </Box>
                <Box mt={2}>
                  <Typography paragraph>You can convert:</Typography>
                  <Typography paragraph color="#FAA631">
                    {Math.floor((stakedLp * lpPriceUSDC) / conversionCost)}
                  </Typography>
                </Box> */}

                <Stack
                  justifyContent={"center"}
                  sx={{ margin: "15px auto 15px auto" }}
                  direction="row"
                  spacing={3}
                >
                  {account ? (
                    <>
                      {" "}
                      <Button
                        sx={{
                          fontSize: mobile ? "15px" : "25px",
                          background: "#FAA631",
                          "&:hover": {
                            background: "white",
                            color: "#FAA631",
                          },
                          color: "white",
                          borderRadius: "10px",
                          paddingX: "20px",
                          fontFamily: "light",
                        }}
                        onClick={() => approveLp(mainNodeAddress)}
                      >
                        APPROVE LP
                      </Button>
                      <Button
                        sx={{
                          fontSize: mobile ? "15px" : "25px",
                          background: "#FAA631",
                          "&:hover": {
                            background: "white",
                            color: "#FAA631",
                          },
                          color: "white",
                          borderRadius: "10px",
                          fontFamily: "light",
                          paddingX: "20px",
                        }}
                        onClick={convertHandler}
                      >
                        Convert
                      </Button>
                    </>
                  ) : (
                    <Button
                      sx={{
                        fontSize: mobile ? "15px" : "25px",
                        background: "#FAA631",
                        "&:hover": {
                          background: "white",
                          color: "#FAA631",
                        },
                        color: "white",
                        borderRadius: "10px",
                        fontFamily: "light",
                        paddingX: "20px",
                      }}
                      onClick={connect}
                    >
                      CONNECT WALLET
                    </Button>
                  )}
                </Stack>
              </TabPanel>

              {/* {CardsState.create ? (
            
              ) : null} */}

              {/* {CardsState.convert ? <></> : null} */}

              {/* <Stack
                justifyContent={"center"}
                sx={{ margin: "15px auto 15px auto" }}
                direction="row"
                spacing={3}
              >
                {CardsState.create ? (
                  <> </>
                ) : CardsState.deposit ? (
                  <> </>
                ) : CardsState.withdraw ? (
                  <></>
                ) : CardsState.convert ? (
                  <></>
                ) : null}
              </Stack> */}
            </Box>

            {/* <Box mt={3} bgcolor="red">
            helo
            </Box>      */}
          </Tabs>
        </Box>

        {mobile ? (
          <>
            <Box pb="80px">
              {/* mf1   */}
              <img
                className="updown"
                src={mf1}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-10px",
                  marginLeft: "40px",
                }}
                alt=""
              />

              {/* mc1   */}
              <img
                src={mc1}
                className="rotate"
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-10px",
                  marginLeft: "210px",
                }}
                alt=""
              />
              {/* mf2   */}
              <img
                src={mf2}
                className="diagonal"
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "20px",
                  marginLeft: "210px",
                }}
                alt=""
              />
            </Box>
          </>
        ) : (
          <>
            {/* c2  */}

            <Box sx={{ position: "relative" }}>
              <img
                className="rotateX"
                src={c2}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-250px",
                  marginLeft: "-20px",
                }}
                alt=""
              />
              {/* c4  */}

              <img
                className="rotate"
                src={c4}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-230px",
                  marginLeft: "1040px",
                }}
                alt=""
              />
              {/* f6  */}

              <img
                className="diagonal"
                src={f6}
                style={{
                  position: "absolute",
                  zIndex: "0",
                  marginTop: "-180px",
                  marginLeft: "1040px",
                }}
                alt=""
              />
            </Box>
          </>
        )}
      </Container>
    </div>
  );
}

export default Stake;
